import { compact } from 'lodash/fp';
import { P, Strong } from '@ahmdigital/ui';

import limitsRollover from './limits-rollover';

export default {
  description: (
    <P>
      You also get <Strong>50%</Strong> back at <Strong>your choice of recognised provider</Strong> on included dental
      services up to your annual limits.
    </P>
  ),
  getSellingPoints: () =>
    compact([
      {
        description: 'up to your annual limit on included extras.',
        title: '50% back at your choice of recognised provider',
      },
      {
        description: 'Use all of your limit on one type of service in the bundle, or spread it across a few.',
        title: 'Annual bundle limits',
      },
      {
        description: 'Available at select dentists.',
        title: 'No gap dental check-ups',
      },
    ]),
  limitsRollover: {
    disclaimer: limitsRollover.disclaimer.choosable,
    rollingOverLimitsText: limitsRollover.rollingOverLimitsText.choosable,
  },
};
